import React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { COLORS } from '@guuru/theme-common';
import Item from './Item';

interface OptionProps {
  theme: DefaultTheme;
  key?: number | string;
  id: number | string;
  name?: string;
  locale?: string;
  onClick?: React.ComponentProps<typeof Item>['onClick'];
  $disabled?: boolean;
  $highlighted?: boolean;
}

const background = function ({ theme, $disabled }: OptionProps) {
  if ($disabled) return COLORS.backgroundOptionDisabled;
  return theme.backgroundColor;
};

const color = function ({ theme, $disabled, $highlighted }: OptionProps) {
  if ($disabled) return COLORS.textOptionDisabled;
  if ($highlighted) return theme.primaryVariants[7];
  return theme.onSurfaceColor;
};

const border = function ({ theme, $disabled, $highlighted }: OptionProps) {
  if ($disabled) return `1px dotted ${theme.neutralVariants[0]}`;
  if ($highlighted) return `2px solid ${theme.primaryColor}`;
  return `1px solid ${theme.neutralVariants[0]}`;
};

export default styled(Item)<OptionProps>`
  padding: 0.5rem;
  border: ${(props) => border(props)};
  margin: 6px 12px 6px 0;
  border-radius: ${({ theme }) => theme.smallRadius};
  width: 100%;
  min-width: inherit;
  font-size: 0.82rem;
  font-weight: ${({ $highlighted }) => ($highlighted ? 600 : 'inherit')};
  background-color: ${(props) => background(props)};
  color: ${(props) => color(props)};
  cursor: ${({ $disabled }) => (!$disabled ? 'pointer' : 'not-allowed')};

  h4 {
    font-weight: 400;
  }

  &:hover {
    text-decoration: none;
    background-color: ${({ theme }) => theme.secondaryColor};
    border-color: ${({ theme }) => theme.primaryVariants[6]};

    &,
    h4,
    div,
    svg {
      color: ${({ theme }) => theme.onSecondaryColor};
    }
  }
`;
